import {Stack} from "@mui/joy";
import {createFileRoute, useNavigate} from "@tanstack/react-router";
import {ToggleBar} from "../../../components/ToggleBar.tsx";
import {TruckCargoView} from "../../../truck/cargo.tsx";
import {useBomb} from "../../../bomb/bomb.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {TruckFacetToggleSwitch} from "../../../truck/truckFacetToggleSwitch.tsx";

function TruckCargoPage() {
    const {id: truckId} = Route.useParams();
    const navigate = useNavigate();
    const bomb = useBomb();
    return <PageShell>
        <PageHeader>
            <Stack direction="column">
                <TopBar/>
                <ToggleBar>
                    <TruckFacetToggleSwitch dispatchValue={(next) => {
                        navigate({
                            to: `/truck/$id/${next}`,
                            params: {id: truckId},
                            replace: true,
                        }).catch(bomb);
                    }} value="cargo"/>
                </ToggleBar>
            </Stack>
        </PageHeader>
        <PageBody>
            <TruckCargoView truckId={truckId}/>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/truck/$id/cargo")({
    component: TruckCargoPage,
});

